

export default{
        vue:null,
        jquery:null,
        init(vuex,jqueryx){
            this.vue = vuex;
            this.jquery = jqueryx;
        },
        trigger(a,b,c,d){
            this.vue.$emit(a,b,c,d);
            this.jquery.trigger(a,b,c,d);
        },
        on(a,b,c,d){
            this.vue.$on(a,b,c,d);
            this.jquery.on(a,b,c,d);
        },
        off(a,b,c,d){
            this.vue.$off(a,b,c,d);
            this.jquery.off(a,b,c,d);
        }
}


// WEBPACK FOOTER //
// ./src/public_app/api/bus.js